import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { SmallCheck } from "./Icons";

const CRITERIA = [
  <>At least <strong>7 open accounts</strong> on your credit report</>,
  <><strong>$10,000 or more</strong> in total credit card limits</>,
  <><strong>Mortgage with payment history</strong> (recommended)</>,
  <><strong>Installment loan nearly paid off</strong> — auto or personal (recommended)</>,
  <><strong>No bankruptcies</strong> in the last 2 years</>,
];

export const Criteria = () => (
  <Reveal className="card" data-testid="criteria-card">
    <div className="section-label">Qualification Requirements</div>
    <h2>Make sure you meet the criteria before applying.</h2>
    <ul className="criteria-list">
      {CRITERIA.map((c, i) => (
        <motion.li key={i} initial={{ opacity: 0, x: -14 }} whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.6, delay: 0.15 + i * 0.08 }}>
          <SmallCheck />
          <span>{c}</span>
        </motion.li>
      ))}
    </ul>
    <div className="note-bar" data-testid="criteria-note">
      <strong>Military affiliation preferred.</strong> Navy Federal or USAA membership qualifies you for significantly larger funding amounts. <strong>All backgrounds are welcome if criteria are met.</strong>
    </div>
  </Reveal>
);
